import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FeatureService } from 'src/app/core/firebase/feature.service';
import { BrockenImageSize, GameSettingsService, ImageType } from 'src/app/core/firebase/gameSettings.service';
import { ProfileStateDispatcher } from 'src/app/core/state/profile/profile.dispatcher';
import { ProfileData } from 'src/app/core/state/profile/profile.state';
import { SopoCheatService } from 'src/app/sopo-cheat.service';

@Component({
    selector: 'app-player-info',
    templateUrl: './player-info.component.html',
    styleUrls: ['./player-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class PlayerInfoComponent implements OnInit {
    profileData = toSignal(this.profileStateDispatcher.getUnfilteredProfileDataObservable());
    isDesktop = signal(false);

    constructor(
        private profileStateDispatcher: ProfileStateDispatcher,
        private sopoCheatService: SopoCheatService,
        private featureService: FeatureService,
    ) { }

    ngOnInit(): void {
        this.isDesktop.set(this.featureService.isDesktop);
    }

    public getAvatarUrl(data: ProfileData) {
        if (data.useNftAsAvatar) {
            if(data.nft!.usingCroppedImage) {
                if (data.nft!.croppedImageUrl) return data.nft!.croppedImageUrl;
                return 'assets/img/cropped_nft_loader.gif'
            }
            return data.nft!.imageUrl;
        }
        return GameSettingsService.getAvatarUrl(data.photoURL);
    }

    onImageError(event: any, size?: BrockenImageSize, type?: ImageType) {
        event.target.src = GameSettingsService.getSopoBrokenImageUrl(size, type);
    }

    async countForCheat(): Promise<void> {
        if (!this.isDesktop()) return;
        await this.sopoCheatService.countForCheat();
    }
}
